import React from "react";
// import utils
import { Navigate, Outlet, useLocation, useOutlet } from "react-router-dom";
// import components
import Header from "./Header";
import { getCookie } from "../utils/functions";

const ProtectedRoutes = () => {
  const outlet = useOutlet(); // for get props children of component
  const { pathname } = useLocation();
  document.title = outlet.props.children.props.children.props.title;
  const token = getCookie("dc-auth");

  if (!token && pathname === "/wating-page") {
    return <Outlet />;
  }
  if (!token && pathname === "/login") {
    return <Outlet />;
  }
  if (!token) {
    return <Navigate to={"/login"} />;
  }
  if (token && pathname === "/login") {
    return <Navigate to={"/"} />;
  }
  return (
    <>
      <Header />
      <div className="relative  pt-[7rem] lg:start-[250px]  lg:w-[calc(100vw_-_267px)]">
        <div className="relative p-4">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default ProtectedRoutes;
